import React from 'react';
import { TextField } from 'wix-ui-tpa';
import withErrorMessage from '../../withErrorMessage';
import { withReadonlySuffix } from '../../../../hooks/withReadonlySuffix';
import { st, classes } from './ShortText.st.css';
const ShortTextComponent = ({ id, className, onBlur, onChange, field: { externalId, renderInfo }, showCharCount = true, invalidMessage, errorMessageId, theme, required, disabled, value = '', inputRef, readonly, }) => {
    var _a, _b, _c, _d, _e;
    const maxLength = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _a === void 0 ? void 0 : _a.maxLength;
    const updatedPrefix = React.useRef(false);
    const fieldType = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.type;
    const inputType = fieldType === 'EMAIL'
        ? 'email'
        : fieldType === 'PHONE'
            ? 'tel'
            : fieldType === 'URL'
                ? 'url'
                : undefined;
    const onValueBlur = () => {
        let updatedValue = value;
        if (inputType === 'url') {
            if (value === '') {
                updatedPrefix.current = false;
            }
            if (value &&
                value !== '' &&
                !updatedPrefix.current &&
                !['http', 'ftp'].find((p) => value.startsWith(p))) {
                updatedPrefix.current = true;
                updatedValue = `https://${value}`;
                onChange(updatedValue);
            }
        }
        onBlur(updatedValue);
    };
    const onValueChange = (newValue) => {
        if (maxLength === undefined ||
            (maxLength && newValue.length <= maxLength)) {
            onChange(newValue);
        }
    };
    return (React.createElement(TextField, { id: id || `${externalId}-input`, label: (_b = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _b === void 0 ? void 0 : _b.label, className: st(classes.root, className), theme: theme, placeholder: (_c = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _c === void 0 ? void 0 : _c.placeholder, disabled: disabled, value: value, type: inputType, inputRef: (ref) => {
            if (inputRef) {
                inputRef(ref);
            }
        }, forceLabel: true, error: !!invalidMessage, "data-hook": "short-text-field", onBlur: () => onValueBlur(), onChange: (e) => onValueChange(e.target.value), required: required, readOnly: readonly, showCharCount: showCharCount, suffix: withReadonlySuffix(readonly), maxLength: (_d = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _d === void 0 ? void 0 : _d.maxLength, pattern: (_e = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _e === void 0 ? void 0 : _e.pattern, "aria-describedby": invalidMessage ? errorMessageId : undefined }));
};
export default withErrorMessage(ShortTextComponent);
//# sourceMappingURL=ShortText.js.map